import {
  Button,
  DialogActions,
  DialogContent,
  HexIcon,
  useSwipeableViews,
  ExternalLink,
  Typography,
  Box,
  Stack,
  tokens,
} from '@cast/design-system';

import { AssignCredentialsDialogHeader } from '../../../_components/AssignCredentialsDialogHeader';

import { getDocsLink } from '@cast/utils';

import { EXTERNAL_LINKS } from '@cast/constants';

type Props = {
  onClose: () => void;
};

export const ErrorSlide = ({ onClose }: Props) => {
  const ctx = useSwipeableViews();

  return (
    <Stack position="relative">
      <AssignCredentialsDialogHeader dismiss={onClose} />
      <DialogContent>
        <Stack gap={4}>
          <Stack direction="row" alignItems="center" gap={8}>
            <HexIcon variant="error" size={40} />
            <Typography variant="h6">Failed to enable GPU metrics</Typography>
          </Stack>
          <Box
            component="ul"
            sx={{
              pl: 60,
              my: 0,
              '& li': { typography: 'P12R', color: 'grey.500' },
            }}
          >
            <li>Double-check if you ran the script correctly</li>
            <li>Check that you&apos;ve run the script in the right context</li>
            <li>
              Check our{' '}
              <ExternalLink
                sx={{ typography: 'P12M' }}
                link={getDocsLink('docs')}
                noIcon
              >
                documentation
              </ExternalLink>
            </li>
            <li>
              Ask a question on our{' '}
              <ExternalLink
                sx={{ typography: 'P12M' }}
                link={EXTERNAL_LINKS.castai_slack_community}
                noIcon
              >
                Community Slack
              </ExternalLink>
            </li>
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{ py: 16, borderTop: tokens.theme.border.structural.neutralSubtle }}
      >
        <Button onClick={onClose} variant="secondary">
          Close
        </Button>
        <Button onClick={() => ctx?.setSlide('runTheScript')}>Retry</Button>
      </DialogActions>
    </Stack>
  );
};
